import React, {useState, useRef, useEffect} from 'react'
import {showToast} from '../../../Component/Toast'
import moment from 'moment'
import axios from 'axios'
import Button from '../../../Component/Button'
import {useHistory} from 'react-router-dom'
import useClientHook from "../../../Hooks/useClientHook";
import Terms from '../Terms'
import Spinner from '../../../Component/Loader'

function Index(props) {

    let HISTORY = useHistory()
    let AGREE = useRef(), EMAIL = useRef(), FNAME = useRef(), LNAME = useRef(), DOB = useRef(), GENDER = useRef(), PHONE = useRef(), COUNTRY = useRef();
    let {client_id, origin} = useClientHook('USER');
    const [BtnLoader, setBtnLoader] = useState(undefined);
	const [LoginMessage, setLoginMessage] = useState();
    const [showTerms, setshowTerms] = useState(undefined);

	let params = new URLSearchParams(window.location.search)

	useEffect(() => {
		if (params.get('success') === 'false') {
			setLoginMessage(new URLSearchParams(window.location.search).get('message'))
		}
        if(DOB.current){
            //Set minimum 16 years age
            DOB.current.max = `${moment().format('YYYY')-16}-${moment().format('MM')}-${moment().format('DD')}`
            //Set maximum 80 years age
        DOB.current.min = `${moment().format('YYYY')-80}-${moment().format('MM')}-${moment().format('DD')}`
        }

	}, [params]);

    const verifyEmail = () => {

        let email = EMAIL.current.value;
        let fname = FNAME.current.value;
        let lname = LNAME.current.value;
        let dob = DOB.current.value;
        let gender = GENDER.current.value;
        let phone = PHONE.current.value;
        let country = COUNTRY.current.value;

        if(!AGREE.current.checked){
            showToast({
                type: 'error',
                message: 'Please agree to Terms of Service'
            })
            return
        }

        if(!fname||!lname){
            showToast({
                type: 'error',
                message: 'Enter full name'
            })
            return
        }
        if(!dob){
            showToast({
                type: 'error',
                message: 'Enter Date of Birth'
            })
            return
        }
        if(gender==='NONE'){
            showToast({
                type: 'error',
                message: 'Select Gender'
            })
            return
        }

        if(!email){
            showToast({
                type: 'error',
                message: 'Enter Email Address'
            })
            return
        }
        email = email.trim()
        let dobStamp = moment(dob,'YYYY-MM-DD')
        dobStamp = moment(dobStamp).valueOf();

		let data = {
            email,
			name: {first: fname, last: lname},
            mobile: phone,
            gender,
            country,
            dob: dobStamp,
            client_id
		}

        setBtnLoader(true)
        axios.post(`https://auth.dice.tech/auth/personal/user`, data).then(res => {
			setBtnLoader(false)
			HISTORY.push(`/personal/verify?email=${email}&origin=${origin}`)

		}).catch(err => {
			setBtnLoader(false)
			showToast({
				type: 'error',
				message: err.response ? err.response.data.message : "Something went Wrong !"
			})
            if(err.response&&err.response.data.message==='User with this email already exists'){
                HISTORY.push(`/personal?origin=${origin}`)
            }
		})

    }

    if(!client_id){
        return <div className='w-100 vh-100 d-flex align-items-center justify-content-center' style={{background: '#fff'}}><Spinner/></div>
    }

	return (
		<>
        <div className="bg-white d-flex align-items-center overflow-hidden" style={{height:'100vh',textTransform: 'none'}}>
			<div className='text-center w-100 p-4'  style={{maxWidth: 450, margin: 'auto'}}>
                <h1 className="display-6 fw-bold">Get Started</h1>
                <p>Enter the details to create your account</p>
                {
					LoginMessage ?
					<p className='text-danger text-left' style={{fontSize: '0.8rem', textAlign: 'left'}}>
						<svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path></svg>
						{LoginMessage}
					</p>
					: <></>
				}
                <div className="mt-4 mb-2 text-start">
                    <div className='d-flex mb-2 w-100'>
                        <input ref={FNAME} type="text" className="form-control w-50 me-2" placeholder="First Name" />
                        <input ref={LNAME} type="text" className="form-control w-50" placeholder="Last Name" />
                    </div>
                    <input ref={EMAIL} type="text" className="form-control" placeholder="Email Address" />
                    <div className='d-flex w-100 mt-3'>
                        <div className='w-50 me-2 text-start'>
                            <label style={{fontSize:'0.7rem'}} className='form-text text-muted col-12 text-truncate' htmlFor="DOB_Input">Date of Birth</label>
                            <input id='DOB_Input' ref={DOB} type="date" className="form-control" style={{textTransform:'uppercase'}}/>
                        </div>
                        <div className='w-50 text-start'>
                            <label style={{fontSize:'0.7rem'}} className='form-text text-muted col-12 text-truncate' htmlFor="Gender_Input">Gender</label>
                            <select id='Gender_Input' ref={GENDER} placeholder='Select Gender' className='form-control'>
                                    <option value='NONE'>Select Gender</option>
                                    <option value='MALE'>Male</option>
                                    <option value={'FEMALE'}>Female</option>
                            </select>
                        </div>
                    </div>
                    <div className='d-flex w-100 mt-2'>
                        <div className='w-50 me-2 text-start'>
                            <label style={{fontSize:'0.7rem'}} className='form-text text-muted col-12 text-truncate' htmlFor="Phone_Input">Phone</label>
                            <input id='Phone_Input' ref={PHONE} type="number" className="form-control" placeholder='Phone' />
                        </div>
                        <div className='w-50 text-start'>
                            <label style={{fontSize:'0.7rem'}} className='form-text text-muted col-12 text-truncate' htmlFor="Country_Input">Country (Optional)</label>
                            <select id='Country_Input' ref={COUNTRY} placeholder='India' className='form-control'>
                                    <option value='+91'>India</option>
                                    <option value='+1'>USA</option>
                                    <option value='+44'>UK</option>
                                    <option value='+1'>Canada</option>
                                    <option value={'+31'}>Europe</option>
                                    <option value={'+61'}>Australia</option>
                            </select>
                        </div>
                    </div>
                </div>
                <p className="text-start" style={{fontSize: '0.8rem'}}>Already have an account?&nbsp; <strong><a className="text-dark" href={`/personal?origin=${origin}`}>Login here</a></strong><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-arrow-right-circle-fill ms-1">
                        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                    </svg>
                </p>
                <p className="text-start d-flex align-items-start" style={{fontSize: '0.8rem'}}>
                    <input id='agreement' ref={AGREE} type='checkbox' className='form-check-input me-2'/>
                    <label class="form-check-label" for="agreement">
                        By selecting you agree to Cleartrip's <span className='cursor-pointer' onClick={()=>setshowTerms(true)}><u>Terms of Service and Privacy Policy</u></span>
                    </label>
                </p>
                <Button onClick={()=>{verifyEmail()}} name='Verify Email' loading={BtnLoader}/>
            </div>
        </div>
        {
            showTerms&&<Terms onClose={()=>setshowTerms(undefined)}/>
        }
		</>
	)
}

export default Index
